// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"playersDisplay__gradient-bg5__HPuIg"};